<template>
  <v-card>
    <v-card-title>
      <v-badge right color="red">
        <span slot="badge">{{ items.length }}</span>
        <h1 class="headline">To be verified</h1>
      </v-badge>
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-model="search"
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      item-key="user_id"
      class="elevation-3 mt-2"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.family_name }}</td>
        <td>{{ props.item.given_name }}</td>
        <td>{{ props.item.middle_name }}</td>
        <td>{{ props.item.ext_name }}</td>
        <td>{{ props.item.username }}</td>
        <!-- <td>{{ props.item.role }}</td> -->
        <td>
          <v-tooltip left lazy color="blue">
            <v-btn flat icon color="blue" slot="activator" @click="openDialog(props.item)">
              <v-icon>done</v-icon>
            </v-btn>
            <span>Verify user</span>
          </v-tooltip>
          <v-tooltip left lazy color="red">
            <v-btn flat icon color="red" slot="activator" @click="deleteAccount(props.item.user_id)">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Delete request</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>

    <v-layout row justify-center>
      <v-dialog v-model="roleDialog" persistent max-width="300">
        <v-card>
          <v-card-title class="headline">Verify User</v-card-title>
          <v-card-text>
            <p>Kindly pick a role for this user.</p>
            <v-layout row wrap>
              <v-flex xs12>
                <v-radio-group v-model="role" row>
                  <v-radio label="Student" :value="true" ></v-radio>
                  <v-radio label="Instructor" :value="false"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="gray" flat @click="roleDialog = false" :disabled="loading">Close</v-btn>
            <v-btn 
              dark
              color="blue darken-1" 
              :loading="loading"
              :disabled="loading"
              @click="verifyAccount()"
            >
              Verify
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-card>
</template>

<script>
import axios from 'axios'
export default {
  data(){
    return {
      search: '',
      headers: [
        { text: 'Family Name', value: 'family_name', align: 'left' },
        { text: 'Given Name', value: 'given_name', align: 'left' },
        { text: 'Middle Name', value: 'middle_name', align: 'left' },
        { text: 'Extension Name', value: 'ext_name', align: 'left' },
        { text: 'Username', value: 'username', align: 'left' },
        // { text: 'Role', value: 'role', align: 'left' },
        { text: 'Operation', value: 'ops', align: 'left', sortable: false },
      ],
      roleDialog: false,
      role: true,
      loading: false,
      item: []
    }
  },
  computed: {
    items(){
      let instructor = this.$store.getters['admin/GET_INSTRUCTORS'].map(item => {
        return { ...item.profile, verified: item.verified, value: false, username: item.username, role: 'Instructor', user_role: item.user_role }
      }).filter(item => !item.verified ? item : null)

      let student = this.$store.getters['admin/GET_STUDENTS'].map(item => {
        return { ...item.profile, verified: item.verified, value: false, username: item.username, role: 'Student', user_role: item.user_role }
      }).filter(item => !item.verified ? item : null)

      let items = instructor.concat(student)
      return items
    }
  },
  methods: {
    openDialog(item){
      this.roleDialog = true
      this.item = item
    },
    // To be fixed
    async verifyAccount(){
      try{
        this.$Progress.start()
        await axios.post('/api/accounts/change', {
          type: 0,
          user_role: this.role ? 2 : 1,
          id: this.item.user_id
        }, { params: { ids: [this.item.user_id] }, headers: { 'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}` }})
        this.$store.dispatch('admin/FETCH_INSTRUCTORS')
        this.$store.dispatch('admin/FETCH_STUDENTS')
        this.role = true
        this.roleDialog = false
        this.$Progress.finish()
      }catch(e){
        console.log(e)
        this.$Progress.fail()
      }
    },
    async deleteAccount(id){
      try{
        confirm('Are you sure you want to delete this user?') && await axios.delete('/api/accounts', {
          params: {
            ids: [id]
          }, headers: { 'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}` } 
        })
        this.$store.dispatch('admin/FETCH_INSTRUCTORS')
        this.$store.dispatch('admin/FETCH_STUDENTS')
      }catch(e){
        console.log(e)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Dashboard/NotVerified.vue